import React, { useId } from 'react';
import './LogoSurface.scss';

// The supplied poster and video share a pale yellow matte. Remove only the
// near-white matte at display time; keep the source files and RGB channels intact.
// Matte alpha = 12 * (2.9 - R - G - B): the matte sums to 2.914; solid logo fills
// stay below 2.57. The small transition range retains antialiased edges.
// Intersect with source alpha: transparent/empty canvas pixels must not become
// opaque black when the matrix's positive offset is applied.
export default function LogoSurface({ children, className = '' }) {
  const filterId = `wiw-logo-matte-${useId().replace(/:/g, '')}`;
  return (
    <span className={`logo-surface ${className}`.trim()} aria-hidden="true"
      style={{ '--logo-matte-filter': `url(#${filterId})` }}>
      <svg className="logo-surface__filter" width="0" height="0" focusable="false">
        <defs>
          <filter id={filterId} colorInterpolationFilters="sRGB">
            <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  -12 -12 -12 0 34.8" result="keyed" />
            <feComposite in="keyed" in2="SourceAlpha" operator="in" />
          </filter>
        </defs>
      </svg>
      {children}
    </span>
  );
}
